export enum SweepOptionTypes {
    PGIM_MM_FUND = 'PMZXX',
    NFS_MM_FUND = 'FDUXX',
    BANK_DEPOSIT = 'QPRMQ'
}
